import { useState } from "react";
import { toast } from "react-hot-toast";
import { formatValidationError } from "../../utils/helper";

const usePost = (apiMethod) => {
  const [isLoading, setIsLoading] = useState(false);
  const [serverErrors, setServerErrors] = useState(null);
  const [error, setError] = useState(null);
  const post = ({ data }) => {
    setIsLoading(true);
    setServerErrors(null);
    setError(null);

    return new Promise((resolve, reject) => {
      apiMethod(data)
        .then((response) => {
          if (response.data.status === 403) {
            post(data);
            return;
          }
          setServerErrors(null);
          if (response.data.response) {
            toast.success(response.data.message);
          } else {
            toast.error(response.data.message);
          }
          resolve(response.data);
        })
        .catch((error) => {
          if (error?.response?.status === 422) {
            const formattedErrors = formatValidationError(error.response.data);
            setServerErrors(formattedErrors?.errors);
            setError(String(formattedErrors?.msg));
          } else {
            setServerErrors(null);
            setError(String(error?.response?.data?.message || error));
            toast.error(
              String(
                error?.response?.data?.message  || error.response?.statusText
              )
            );
          }

          reject(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    });
  };

  return { isLoading, serverErrors, post, error };
};

export default usePost;
